import * as React from 'react';
import LoadingIndicator from './LoadingIndicator';

type Props = {
  message: string;
};

export default class MaskedLoadingIndicator extends React.Component<Props> {
  render() {
    return (
      <div
        style={{
          // background translucent mask
          background: 'rgba(100,100,100,0.7)',
          top: '0',
          bottom: '0',
          left: '0',
          right: '0',
          position: 'absolute' as 'absolute',
          zIndex: 50000,
        }}
      >
        <div
          style={{
            // dialog
            color: '#666',
            background: '#eee',
            fontSize: '20px',
            fontFamily: 'sans-serif, monospace',
            textAlign: 'center',
            padding: '15px 20px',
            position: 'absolute',
            border: '3px outset #666',
            top: '45%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <LoadingIndicator>
            {this.props.message}
            ...
          </LoadingIndicator>
        </div>
      </div>
    );
  }
}
